import { Button } from 'react-bootstrap';
import { PlusCircle } from 'react-bootstrap-icons';

const EmptyState = ({ title, description, actionLabel, onAction, disabled = false }) => (
  <div className="empty-state text-center py-5">
    <PlusCircle size={48} className="empty-state__icon mb-3" />
    <h3 className="empty-state__title">{title}</h3>
    <p className="empty-state__description">{description}</p>
    {actionLabel && onAction && (
      <Button variant="secondary" onClick={onAction} disabled={disabled} className="mt-2">
        {actionLabel}
      </Button>
    )}
  </div>
);

export default EmptyState;